import React from 'react';
import {Box, Button, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material';
import {DeleteForeverOutlined} from '@mui/icons-material';
import {alpha} from '@mui/material/styles';
import {SettingsDialog} from '../settings/SettingsDialog';
import {getSettingsColors} from '../settings/SettingsDesign';

export const automationFieldGrid = {
    display: 'grid', gridTemplateColumns: {xs: 'minmax(0, 1fr)', sm: 'repeat(2, minmax(0, 1fr))'}, gap: 2, minWidth: 0
};

export const automationSelectPaperStyles = {
    bgcolor: theme => theme.palette.mode === 'light' ? theme.palette.background.paper : getSettingsColors(theme).input,
    color: 'text.primary', borderRadius: '10px', border: '1px solid', borderColor: 'divider',
    '& .MuiMenuItem-root, & .MuiAutocomplete-option': {fontSize: 13, minHeight: '36px !important'}
};

export const automationSelectMenuProps = {PaperProps: {sx: automationSelectPaperStyles}};

export function AutomationDialog({sx = [], ...props}) {
    return <SettingsDialog {...props} sx={[{
        '& .MuiDialogContent-root': {position: 'relative', minWidth: 0},
        '& .MuiDialogTitle-root + .MuiDialogContent-root': {pt: 1.5},
        '& .MuiDialog-paper': {
            '& .MuiTextField-root': {my: 0, minWidth: 0},
            '& .MuiFormControl-root': {minWidth: 0},
            '& .MuiOutlinedInput-root': {bgcolor: theme => theme.palette.mode === 'light' ? theme.palette.background.paper : getSettingsColors(theme).input},
            '& .automation-nested-inputs .MuiOutlinedInput-root': {bgcolor: theme => getSettingsColors(theme).input},
            '& .MuiOutlinedInput-input': {fontSize: 13},
            '& .MuiFormControlLabel-label': {fontSize: 13},
            '& .MuiRadioGroup-root': {gap: 1, '& .MuiFormControlLabel-root': {ml: 0, mr: 1.5}},
            '& .MuiButton-root': {textTransform: 'none', boxShadow: 'none', minHeight: 36},
            '& .MuiAlert-root': {borderRadius: '10px', fontSize: 13, lineHeight: 1.7}
        }
    }, ...(Array.isArray(sx) ? sx : [sx])]}/>;
}

export function AutomationSection({title, description, children}) {
    const titleId = React.useId();
    return <Box component="section" aria-labelledby={titleId} sx={{p: {xs: 2, sm: 2.5}, borderRadius: '12px',
        minWidth: 0, bgcolor: theme => getSettingsColors(theme).inset}}>
        <Typography component="h3" id={titleId} sx={{fontSize: 14, fontWeight: 600}}>{title}</Typography>
        {description && <Typography sx={{fontSize: 13, color: 'text.secondary', mt: 0.5, lineHeight: 1.6}}>{description}</Typography>}
        <Box sx={{mt: 2, display: 'grid', gap: 2, minWidth: 0}}>{children}</Box>
    </Box>;
}

export function AutomationDeleteDialog({confirm, ruleName}) {
    const id = React.useId();
    return <AutomationDialog open fullWidth maxWidth="xs" onClose={() => confirm(false)}
        aria-labelledby={`${id}-title`} aria-describedby={`${id}-description`}
        sx={{'& .MuiDialog-paper': {borderRadius: '16px'}}}>
        <DialogTitle id={`${id}-title`}>
            <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5}}>
                <Box sx={{display: 'flex', p: 1, borderRadius: '10px', color: 'error.main',
                    bgcolor: theme => alpha(theme.palette.error.main, 0.1)}}><DeleteForeverOutlined/></Box>
                <Box component="span">Delete rule?</Box>
            </Box>
        </DialogTitle>
        <DialogContent>
            <Typography id={`${id}-description`} sx={{fontSize: 14, color: 'text.secondary', lineHeight: 1.7, overflowWrap: 'anywhere'}}>
                {ruleName ? <>The rule <Box component="span" sx={{fontWeight: 600, color: 'text.primary'}}>“{ruleName}”</Box></> : 'The selected rule'} will be permanently deleted. This action cannot be undone.
            </Typography>
        </DialogContent>
        <DialogActions>
            <Button color="inherit" onClick={() => confirm(false)}>Cancel</Button>
            <Button variant="contained" color="error" onClick={() => confirm(true)}>Delete rule</Button>
        </DialogActions>
    </AutomationDialog>;
}
